export default {
  googleAuthorizeTerms: "2023 年 3 月 10 日後，我們將停止支援此應用程式。請安裝新版 {googleAppName}。"
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
